var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white shadow-custom h-auto p-4 rounded-sm",class:{'text-center': _vm.center, 'mx-1.5': _vm.gutters}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }